export enum InternalStatusActionTypes{
    API_RESPONSE_SUCCESS = "@@internalStatus/API_RESPONSE_SUCCESS",
    API_RESPONSE_ERROR = "@@internalStatus/API_RESPONSE_ERROR",
    GET_INTERNAL_STATUS = "@@internalStatus/GET_INTERNAL_STATUS",
    ADD_INTERNAL_STATUS = "@@internalStatus/ADD_INTERNAL_STATUS",
    UPDATE_INTERNAL_STATUS = "@@internalStatus/UPDATE_INTERNAL_STATUS",
    DELETE_INTERNAL_STATUS = "@@internalStatus/DELETE_INTERNAL_STATUS",
}